<template>
  <div class="has-background-white is-border">
    <tabs
      class="has-background-white is-border-bottom"
      :level="0">
      <li :class="{'is-active' : panel === 'ACTIVITY'}">
        <a @click="changePanel(PANELS.ACTIVITY)">
          <span class="is-size-3">Activité Structure</span>
        </a>
      </li>
      <li :class="{'is-active' : panel === 'MONITORING'}">
        <a @click="changePanel(PANELS.MONITORING)">
          <span class="is-size-3">Monitoring</span>
        </a>
      </li>
    </tabs>

    <div
      class="columns is-multiline is-gapless"
      v-if="panel === 'MONITORING'">
      <router-link
        :to="{name: 'UserList'}"
        class="column is-6 is-border-bottom is-border-right is-border--dashed is-padding graph-over graph-over--decoration">
        <div>
          <div><span class="is-size-6 has-text-grey">Utilisateurs</span></div>
          <div class="is-padding-top-xsmall">
            <span class="is-size-4">{{ totalUser }} Utilisateur<span v-if="totalUser > 1">s</span></span>
            <br>
            <span class="is-size-7">{{ totalAccount }} sociétés</span>
          </div>
        </div>
      </router-link>
      <router-link
        :to="{name: 'ProgramCardList'}"
        class="column is-6 is-border-bottom is-border-right is-border--dashed is-padding graph-over graph-over--decoration">
        <div>
          <div><span class="is-size-6 has-text-grey">Stock disponible</span></div>
          <div class="is-padding-top-xsmall">
            <span class="is-size-4">{{ totalProgram }} programme<span v-if="totalProgram > 1">s</span></span>
            <br>
            <span class="is-size-7">{{ totalLot }} lot<span v-if="totalLot > 1">s</span></span>
          </div>
        </div>
      </router-link>
      <router-link
        :to="{name: 'OptionList'}"
        class="column is-6 is-border-bottom is-border-right is-border--dashed is-padding graph-over graph-over--decoration">
        <div>
          <div><span class="is-size-6 has-text-grey">Option</span></div>
          <div class="is-padding-top-xsmall">
            <span class="is-size-4">
              {{ runningOptions }} option<span v-if="runningOptions >1">s</span> en cours
            </span>
            <br>
            <span class="is-size-7">{{ pendingClaims }} dénonciation<span v-if="pendingClaims > 1">s</span> en attente</span>
          </div>
        </div>
      </router-link>
      <router-link
        :to="{name: 'OptionList', query: { reservation__status: 'pending' }}"
        class="column is-6 is-border-bottom is-border-right is-border--dashed is-padding graph-over graph-over--decoration">
        <div>
          <div><span class="is-size-6 has-text-grey">Dossier en attente</span></div>
          <div class="is-padding-top-xsmall">
            <span class="is-size-4">{{ pendingReservations }} en attente<span v-if="pendingReservations > 1">s</span></span><br>
          </div>
        </div>
      </router-link>
      <!-- RGPD : contacts à supprimer / à anonymiser, clic vers la liste pré-filtrée -->
      <router-link
        id="rgpdToDelete"
        :to="{name: 'ContactList', query: { rgpd_status: 'to_delete' }}"
        class="column is-6 is-border-bottom is-border-right is-border--dashed is-padding graph-over graph-over--decoration">
        <div>
          <div><span class="is-size-6 has-text-grey">RGPD à supprimer</span></div>
          <div class="is-padding-top-xsmall">
            <span class="is-size-4">{{ rgpdStats.to_delete }} contact<span v-if="rgpdStats.to_delete > 1">s</span></span>
            <br>
            <span class="is-size-7">aucune activité depuis plus de 5 ans</span>
          </div>
        </div>
      </router-link>
      <router-link
        id="rgpdToAnonymize"
        :to="{name: 'ContactList', query: { rgpd_status: 'to_anonymize' }}"
        class="column is-6 is-border-bottom is-border-right is-border--dashed is-padding graph-over graph-over--decoration">
        <div>
          <div><span class="is-size-6 has-text-grey">RGPD à anonymiser</span></div>
          <div class="is-padding-top-xsmall">
            <span class="is-size-4">{{ rgpdStats.to_anonymize }} contact<span v-if="rgpdStats.to_anonymize > 1">s</span></span>
            <br>
            <span class="is-size-7">activité terminée depuis plus de 5 ans</span>
          </div>
        </div>
      </router-link>
    </div>
    <dashboard-stats-activity
      v-if="panel === 'ACTIVITY'"
      :stats-sales="statsSales"
      :stats-sales-reference="statsSalesReference"
      :users="users"
      :future-rdvs-count="futureRdvsCount"
      :future-rdvs="futureRdvs"></dashboard-stats-activity>
  </div>
</template>

<script>
const PANELS = Object.freeze({
  MONITORING: 'MONITORING',
  ACTIVITY: 'ACTIVITY'
})
export default {
  name: 'DashboardStats',
  components: {
    DashboardStatsActivity: () => import('./DashboardStatsActivity')
  },
  props: {
    totalProgram: {
      type: Number,
      default: 0
    },
    totalLot: {
      type: Number,
      default: 0
    },
    totalAccount: {
      type: Number,
      default: 0
    },
    totalUser: {
      type: Number,
      default: 0
    },
    pendingClaims: {
      type: Number,
      default: 0
    },
    runningOptions: {
      type: Number,
      default: 0
    },
    pendingReservations: {
      type: Number,
      default: 0
    },
    futureRdvs: Array,
    futureRdvsCount: {
      type: Number,
      default: 0
    },
    statsSales: Array,
    statsSalesReference: Array,
    users: Array,
    rgpdStats: {
      type: Object,
      default: () => ({ to_delete: 0, to_anonymize: 0 })
    }
  },
  data () {
    return {
      panel: PANELS.ACTIVITY,
      PANELS: PANELS
    }
  },
  methods: {
    /**
      * change panel
      * @param {string} - panel name
      */
    changePanel (panel) {
      this.panel = panel
    }
  }
}
</script>
